import React from 'react';
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Provider } from 'react-redux';
import FaqModal from "src/components/FaqModal";
import LoginPickerScreen from "src/components/LoginPickerScreen";
import ReactRoutes from "src/constants/react-routes";
import store from 'src/redux/store';
import ContactHelpScreen from './alumni/ContactHelpScreen';
import ContactInfoSelectScreen from './alumni/ContactInfoSelectScreen';
import WelcomeScreen from './alumni/WelcomeScreen';
import Help from './alumni/Help';
import { persistStore } from 'redux-persist';
import { PersistGate } from 'redux-persist/integration/react'

function App() {
    return (
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistStore(store)}>
                <BrowserRouter>
                    <Routes>
                        <Route path={ReactRoutes.ROOT} element={<LoginPickerScreen />} />
                        <Route path={ReactRoutes.WELCOME} element={<WelcomeScreen />} />
                        <Route path={ReactRoutes.ALUMNI_WELCOME} element={<WelcomeScreen />} />
                        <Route path={ReactRoutes.ALUMNI_CONTACT_HELP} element={<ContactHelpScreen /> } />
                        <Route path={ReactRoutes.ALUMNI_CONTACT_SELECT} element={<ContactInfoSelectScreen /> } />
                        <Route path={ReactRoutes.ALUMNI_FAQ} element={<Help /> } />
                    </Routes>
                </BrowserRouter>
                <FaqModal />
            </PersistGate>
        </Provider>
    );
}

export default App;
